module.exports = __webpack_public_path__ + "img/ic-head.fbf43ac1.png";